<template>
  <form @submit.prevent="validateForm" class="reset-password ine-form__form">
    <div class="ine-form__title-wrapper">
      <h4 class="ine-form__welcome">Reset User's Password</h4>
      <p class="ine-form__lead-in">
        Please enter the users email address
      </p>
    </div>
    <div class="ine-form__form-group">
      <input
        @keyup="validateEmail()"
        type="email"
        class="ine-form__form-control"
        placeholder="email"
        v-model="email"
      />
      <div class="ine-form__form-group">
        <input
          @keyup="validatePassword()"
          type="text"
          class="ine-form__form-control"
          placeholder="password"
          v-model="password"
        />
        <br />
        <p class="ine-form__helper">
          Password must be at least 8 characters long. <br />
          Contain at least one number. <br />
          Contain at least one capital letter.
        </p>
      </div>
    </div>
    <div class="ine-form__submit-btn-wrapper">
      <button
        v-show="!loading"
        class="ine-form__submit-btn btn__auth"
        type="submit"
      >
        Reset Password
        <span class="material-icons btn__auth--icon">person</span>
      </button>
      <ClipLoader v-show="loading" :size="1.5" sizeUnit="rem"></ClipLoader>
    </div>
    <div
      v-show="!loading"
      class="ine-form__additional-links-wrapper ine-form__homepage-link"
    >
      <router-link class="ine-form__additional-link" :to="{ name: 'home' }"
        >Back to Homepage</router-link
      >
    </div>
    <div class="ine-form__new-password-wrapper" v-show="newPassword">
      Password changed to:
      <span class="ine-form__new-password">{{ newPassword }}</span>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'ResetPassword',
  components: {
    ClipLoader,
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
    }
  },
  props: {
    emailValid: {
      type: Boolean,
      required: true,
    },
    passwordValid: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      newPassword: 'admin/usersNewPassword',
    }),
  },
  methods: {
    clearPassword() {
      this.$store.dispatch('admin/setNewPassword', '')
    },
    validateEmail() {
      this.$emit('emailTest', this.email)
    },
    validatePassword() {
      this.$emit('passwordTest', this.password)
    },
    async validateForm() {
      this.loading = true
      if (!this.emailValid) {
        this.$store.dispatch('app/setError', 'Please enter a valid email.')
      } else if (!this.passwordValid) {
        this.$store.dispatch('app/setError', 'Please enter a valid password.')
      } else {
        const preparedEmail = this.email.toLowerCase().trim()
        const { password } = this
        await this.forceResetPassword({ email: preparedEmail, password })
      }
      this.loading = false
    },
    async forceResetPassword(preparedEmail) {
      await this.$store.dispatch('admin/adminResetPassword', preparedEmail)
    },
  },
  destroyed() {
    this.clearPassword()
  },
}
</script>

<style lang="scss" scoped>
.reset-password {
  &__new-password-wrapper {
    font-size: 2rem;
  }
  &__new-password {
    color: var(--orange);
  }
}
</style>
